<template>
  <div align="left">
    <el-radio v-model="radio" label="1">感染性</el-radio>
    <el-radio v-model="radio" label="2">损伤性</el-radio>
<p>
  起始编号：<el-input-number v-model="start"  :min="1" :max="1000" label="描述文字"></el-input-number>
</p>
    <p>

    打印数量：<el-input-number v-model="num"  :min="1" :max="1000" label="描述文字"></el-input-number>
    </p>
    <el-button type="primary" icon="el-icon-printer" @click="printQR" >打印二维码</el-button>
    <div id="qrcode"></div>
  </div>
</template>
<script>

  import QRCode from 'qrcodejs2'
  export default {
    name: "QRPrinter",
    data(){
      return {
        radio:"1",
        start:1,
        num:1,
      }
    },
    methods: {
      printQR(){
        if (this.start<=0){
          this.start=1
        }
        if (this.num<=0){
          this.num=1
        }
        const params = { id: window.companyID,name:window.companyName,time:this.getTime(),type:this.radio,start:this.start,end:this.start+this.num-1 };
        let routeData = this.$router.resolve({
          path: "/qr/",
          query: params,
        });
        window.open(routeData.href, '_blank');
      },
      makeCode(id,name,t,num){
        return this.getTime()+"-"+id +"-"+t+"-"+num+"|"+name
      },
      getTime(){
        var t =new Date();
        return this.appendZero(t.getFullYear()%100)+""+this.appendZero(t.getMonth()+1)+this.appendZero(t.getDate())
      },
      appendZero(obj) {
        if (obj < 10) {
          return "0" + obj;
        } else {
          return obj;
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/QRPrinter.vue